export type Language = {
  value: Languages;
  label: string;
  activeColor: string;
  inactiveColor: string;
};

export enum Languages {
  AR = 1,
  EN = 2,
}

export const languages: Language[] = [
  {
    value: Languages.AR,
    label: 'Arabic',
    activeColor: '#1f798320',
    inactiveColor: '#1f7983',
  },
  {
    value: Languages.EN,
    label: 'English',
    activeColor: '#e5dfeb',
    inactiveColor: '#640080',
  },
];
